import React, { useState, useMemo } from "react";
import './AllRulesModal.css';

const GameRulesModal = ({
  data,
  setSelectedRule,
  groupModal,
  closeModal,
  loading,
}) => {

  const [step, setStep] = useState(1); // Step 1 = selection, Step 2 = show rules
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  // Filter rules based on selected options - moved before any conditional returns
  const filteredRules = useMemo(() => {
    if (!data || !selectedGender || !selectedType) return [];
    return data.filter(
      (d) => d.gender === selectedGender && d.type === selectedType
    );
  }, [data, selectedGender, selectedType]);

  // Conditional return should come after all hooks
  if (!groupModal) return null;

  const handleNext = () => {
    if (selectedGender && selectedType) {
      setStep(2);
    } else {
      alert("Please select both Gender and Type");
    }
  };

  const handleBack = () => {
    setStep(1);
    setSelectedRule(null); // reset selected rule if going back
  };

  return (
    <div className="positionOverlay">
      <div className="modalView">
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "0 27px" }}>
          <button onClick={closeModal} className="close-btn" style={{ fontSize: "30px" }}>
            &times;
          </button>
        </div>

        <h2 className="selectPositionTxt">SELECT GAME RULES</h2>

        {loading ? (
          <div className="loader"></div>
        ) : (
          <>
            {step === 1 && (
              <div className="row-view">
                <div className="gender-section">
                  <h3 className="gender-heading">Choose Gender</h3>
                  <div className="options">
                    <button
                      className={`btnRules ${selectedGender === "male" ? "active" : ""}`}
                      onClick={() => setSelectedGender("male")}
                    >
                      Male
                    </button>
                    <button
                      className={`btnRules ${selectedGender === "female" ? "active" : ""}`}
                      onClick={() => setSelectedGender("female")}
                    >
                      Female
                    </button>
                  </div>
                </div>

                <div className="gender-section">
                  <h3 className="gender-heading">Choose Type</h3>
                  <div className="options">
                    <button
                      className={`btnRules ${selectedType === "field" ? "active" : ""}`}
                      onClick={() => setSelectedType("field")}
                    >
                      Field
                    </button>
                    <button
                      className={`btnRules ${selectedType === "sixes" ? "active" : ""}`}
                      onClick={() => setSelectedType("sixes")}
                    >
                      Sixes
                    </button>
                  </div>
                </div>

                <div style={{ marginTop: "20px", textAlign: "center", }}>
                  <button className="btnRules" style={{backgroundColor: "green"}} onClick={handleNext}>
                    Next
                  </button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="rules-section">
                <h3 className="gender-heading">
                  {selectedGender.toUpperCase()} - {selectedType.toUpperCase()} RULES
                </h3>

                {filteredRules.length > 0 ? (
                  filteredRules.map((val, ind) => (
                    <button
                      key={ind}
                      onClick={() => setSelectedRule(val)}
                      className="btn"
                    >
                      {val.ruleName}
                    </button>
                  ))
                ) : (
                  <p>No rules found for this selection.</p>
                )}

                <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <button className="btnRules" style={{backgroundColor: "green"}} onClick={handleBack}>
                    Back
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default GameRulesModal;